import request from '@/utils/request'
import { blobValidate } from '@/utils/ruoyi'
import { saveAs } from 'file-saver'
import { Message } from 'element-ui'

// 查询【请填写功能名称】列表
export function listApplication(query) {
  return request({
    url: '/dev-api/application/list',
    method: 'get',
    params: query
  })
}

// 下载申报报告
export function downloadApplicationReport(params, filename) {
  return request({
    url: '/dev-api/application/downloadReport',
    method: 'get',
    params,
    responseType: 'blob',
    validateStatus: (status) => status >= 200 && status < 500
  }).then(async (data) => {
    const isBlob = blobValidate(data)
    if (isBlob) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      })
      saveAs(blob, filename)
      return
    }
    const resText = await data.text()
    let errMsg = '下载失败，请稍后重试'
    try {
      const rspObj = JSON.parse(resText)
      errMsg = rspObj.msg || errMsg
    } catch (e) {
      // ignore parse error
    }
    Message.error(errMsg)
    return Promise.reject(new Error(errMsg))
  })
}

// 查询【请填写功能名称】详细
export function getApplication(id) {
  return request({
    url: '/application/' + id,
    method: 'get'
  })
}

// 新增【请填写功能名称】
export function addApplication(data) {
  return request({
    url: '/dev-api/application',
    method: 'post',
    data: data
  })
}

// 修改【请填写功能名称】
export function updateApplication(data) {
  return request({
    url: '/application',
    method: 'put',
    data: data
  })
}

// 删除【请填写功能名称】
export function delApplication(id) {
  return request({
    url: '/system/application/' + id,
    method: 'delete'
  })
}

